import React, { useState, useCallback, useEffect, useContext } from 'react'
// import { useHistory } from 'react-router-dom'
import styled, { ThemeContext } from 'styled-components'
import MysteryBoxCard from './MysteryBoxCard'
import { ButtonYellowLight } from '../../../components/Button'

// swiper
import { windowSize } from '../../../utils/func'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.min.css'
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);

const MysteryBoxWrapper = styled.div`
  max-width: 1440px;
  margin: auto;
  margin-top: 64px;
  position: relative;
  box-sizing: border-box;
  padding: 0px 25px;
`
const Title = styled.div`
  
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  color: ${({ theme }) => theme.bsText32};
`

const SwiperWrapper = styled.div`
  min-height: 350px;
  position: relative;
  display: flex;
  grid-row-gap: 20px;
  grid-column-gap: 20px;
  justify-content: flex-start;
  grid-template-columns: repeat(auto-fill, 272px);
  flex-wrap: nowrap;
  overflow: auto;
  margin-top: 20px;
  max-width: 100%;
  padding: 10px;
  box-sizing: border-box;
  .swiper-pagination {
    display: none;
  }
  .swiper-pagination-bullet {
    background: rgba(255, 255, 255, 0.9);
  }
  .swiper-pagination-bullet-active {
    background: #fffdfa;
  }
`
const NextRightIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  right: 10px;
  top: 210px;
  cursor: pointer;
`
const PrevLeftIcon = styled.img`
  width: 50px;
  height: 50px;
  position: absolute;
  z-index: 1;
  left: 10px;
  top: 210px;
  cursor: pointer;
`

const Button = styled(ButtonYellowLight)`
  width: 326px;
  height: 48px;
  margin: auto;
  margin-top: 45px;
  color: #FF7A00;
  align-items: center;
  display: flex;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 80%;
    margin: 0px auto;
  `}
`

export default function MysteryBoxes() {
  const theme = useContext(ThemeContext)
  // const history = useHistory();

  const mysteryBoxList = [
    {
      image: '/images/mysteryBox/hiphop2.png',
      title: 'Masterminds of Hip Hop NFT Mystery Box Sale',
      num: '5,000',
      urlName: 'https://gallery.bakeryswap.org/mysteryBox/box/?type=HIPHOP&&nftType=112',
    },
    {
      image: '/images/mysteryBox/hiphop.png',
      title: 'Masterminds of Hip Hop NFT Mystery Box Sale',
      num: '10,000',
      urlName: 'https://gallery.bakeryswap.org/mysteryBox/box/?type=HIPHOP&&nftType=112',
    },
    {
      image: '/images/mysteryBox/blin.png',
      title: 'Blin Metaverse',
      num: '10,000',
      urlName: 'https://gallery.bakeryswap.org/mysteryBox/box/?type=DONGHUANG'
    },
    {
      image: '/images/mysteryBox/onePiece.png',
      title: 'One Piece Mystery Box Information',
      num: '999',
      urlName: 'https://gallery.bakeryswap.org/mysteryBox/box/?type=ONEPIECE'
    }
  ]


  // swiper
  const upToSmall = 500
  const upToMedium = 960
  const upMoreMedium = 1300
  const upToExtraLarge = 1440
  const upToLessLarge = 1520
  const upToMoreLarge = 1600
  const upToLarge = 1750
  const emptySwiper: any = null
  const [swiper, setSwiper] = useState(emptySwiper)
  const [width, setWidth] = useState(windowSize().w)
  const params = {
    loop: true,
    slidesPerView: 2.1,
    spaceBetween: 16,
    pagination: {
      clickable: true,
    },
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    onSwiper: setSwiper
  }
  useEffect(() => {
    if (swiper) {
      if (width <= upToSmall) {
        swiper.params.slidesPerView = 1.1
        swiper.params.spaceBetween = 16
      } else if (width <= upToMedium) {
        swiper.params.slidesPerView = 1
        swiper.params.spaceBetween = 16
      } else if (width <= upMoreMedium) {
        swiper.params.slidesPerView = 1.2
        swiper.params.spaceBetween = 16
      } else if (width <= upToExtraLarge) {
        swiper.params.slidesPerView = 1.6
        swiper.params.spaceBetween = 16
      } else if (width <= upToLessLarge) {
        swiper.params.slidesPerView = 1.7
        swiper.params.spaceBetween = 16
      } else if (width <= upToMoreLarge) {
        swiper.params.slidesPerView = 1.8
        swiper.params.spaceBetween = 16
      } else if (width <= upToLarge) {
        swiper.params.slidesPerView = 2
        swiper.params.spaceBetween = 16
      } else {
        swiper.params.slidesPerView = 2.1
        swiper.params.spaceBetween = 16
      }
      swiper.autoplay.stop()
    }
  }, [width, swiper])

  const handleResize = useCallback(() => {
    const size = windowSize()
    setWidth(size.w)
  }, [width])

  useEffect(() => {
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [handleResize])

  const slideNext = useCallback(() => {
    swiper.slideNext()
  }, [swiper])

  const slidePrev = useCallback(() => {
    swiper.slidePrev()
  }, [swiper])

  const goMysteryBox = () => {
    // history.push(`/gamification/gameace`)
    window.open("https://gallery.bakeryswap.org/mysteryBox")
  }

  return (
    <MysteryBoxWrapper>
      <Title>
        Mystery Box
      </Title>
      <SwiperWrapper>
        <Swiper {...params}>
          {
            mysteryBoxList.map((d, index) => {
              return (
                <SwiperSlide key={index}>
                  <MysteryBoxCard box={d}></MysteryBoxCard>
                </SwiperSlide>
              )
            })
          }
        </Swiper>
      </SwiperWrapper>
      <NextRightIcon src={theme.darkMode ? "/images/icon/next-dark.png" : "/images/icon/next.png"} onClick={slideNext} />
      <PrevLeftIcon src={theme.darkMode ? "/images/icon/prev-dark.png" : "/images/icon/prev.png"} onClick={slidePrev}/>
      <Button onClick={() => goMysteryBox()}>All Mystery Boxes</Button>
    </MysteryBoxWrapper>
  )
}